import { logoutUser } from '../helpers/auth';
import { setTwoFactorStatus } from '../../Features/Auth/actionCreator';
import { showErrorNotification } from '../../Features/Notifications/actions';

const errorMessage = 'An error occurred. Please refresh the page and try again.';

export const setErrorInterceptor = async (error, store) => {
  if (error.message === 'Cancel request') {
    return Promise.reject(error);
  }
  if (error.response === undefined) {
    return Promise.reject(error);
  }

  const {
    response: { status, data },
  } = error;

  if (status === 403) {
    if (data.type === 'need_totp_setup' || data.type === 'need_totp_verification')
      store.dispatch(setTwoFactorStatus(data.type));
  }

  if (status === 422 && data.errors) {
    const { errors } = data;
    const errorsKeys = Object.keys(errors);
    errorsKeys.forEach((key) => {
      store.dispatch(showErrorNotification(errors[key][0]));
    });
  }

  if (status === 401 || status === 419) {
    // Log out the user client-side
    await logoutUser(true, 'Session expired. Please log in again.');
    // Promise already handled through logout
    return new Promise(() => {});
  }

  if (status >= 500) {
    store.dispatch(showErrorNotification(errorMessage));
  }

  return Promise.reject(error);
};

export default setErrorInterceptor;
